import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLinesTriangular12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconLinesTriangular12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M.917 3.5a.5.5 0 0 1 .5-.5h9.166a.5.5 0 0 1 0 1H1.417a.5.5 0 0 1-.5-.5m2 2.5a.5.5 0 0 1 .5-.5h5.166a.5.5 0 0 1 0 1H3.417a.5.5 0 0 1-.5-.5m2.5 2a.5.5 0 0 0 0 1h1.166a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLinesTriangular12);
